import { Component, EventEmitter, Input, OnInit, Output, ViewEncapsulation } from '@angular/core';
import { MatDialogRef } from '@angular/material';
import { Store } from '@ngrx/store';
import { DisposableSafelly } from '@toro/common/shared/components/disposable-safelly/disposable-safelly.component';
import { OrderMarketTypeEnum } from '@toro/common/shared/enum/orders/market-type.enum';
import { AppState } from '@toro/common/shared/interfaces/app-state.interface';
import { ConsolidatedPosition } from '@toro/common/shared/models/pos-risk/consolidated-position';
import { DialogsService } from '@toro/common/shared/services/dialogs.service';
import { FinanceActions } from '@toro/common/shared/state-management/finance/finance.action';
import { filter } from 'rxjs/operators';
import { ICheckoutStock } from '../../../../../interfaces/checkout.interface';
import { CheckoutAboutFeesComponent } from '../checkout-about-fees/checkout-about-fees.component';
import { DialogPriceEditionComponent } from '../dialog-price-edittion/dialog-price-edition.component';


@Component({
selector: 'checkout-manual',
templateUrl: './checkout-manual.component.html',
styleUrls: ['./checkout-manual.component.scss'],
encapsulation: ViewEncapsulation.None,
})
export class CheckoutManualComponent extends DisposableSafelly implements OnInit {

    @Input('stock') public stock: ICheckoutStock;
    @Output() public close = new EventEmitter();

    public isAutomatic: boolean = false;
    public dialogComponentReference: MatDialogRef<DialogPriceEditionComponent>;
    public typeMarketEnum = OrderMarketTypeEnum;
    public closingTimeDayTrade: string | Date;
    public closingTimeBovespa: string | Date;
    public dialogAboutFeesReference: MatDialogRef<CheckoutAboutFeesComponent>;
    public consolidatedPosition: ConsolidatedPosition;
    public userCblc: string;

    public tooltipBalloon: string = `<div>
        <div class='pop-content font-gray-color--darker'>
            <strong>Corretagem Zero</strong>
            <p>Não existe cobrança de corretagem quando você opera enviando ordens manualmente para comprar e vender ativos.</p>
        </div>
    </div>`;

    constructor(
        protected dialogsServices: DialogsService,
        private store: Store<AppState>
    ) {
        super();
    }

    public ngOnInit() {
        this.disposableSubscriptions.push(
            this.store.select((store) => store.exchange.tradingTime)
                .subscribe((data) => {
                    this.closingTimeBovespa = data.limitDayTradeStock;
                    this.closingTimeDayTrade = data.limitDayTradeFuture;
                }));

        this.store.select((state) => state.finance.consolidatePosition)
            .pipe(
                filter((consolidatePosition) => !!consolidatePosition))
                .subscribe(consolidatedPosition => this.consolidatedPosition = consolidatedPosition);

        this.store.dispatch({ type: FinanceActions.getRealtimeFinancePosition });
    }

    // Abre a dialog para atualização do preço
    public changeDealBest() {
        const dialogSettings: {} = {
            ...this.stock,
            isAutomatic: false,
        };
        this.dialogComponentReference =
            (this.dialogsServices.showComponentAsAsidePanel(DialogPriceEditionComponent, true, dialogSettings) as
                MatDialogRef<DialogPriceEditionComponent>);
        this.disponsableEditPrice(this.dialogComponentReference);
    }

    // Observa e atualiza o preço que veio editado da dialog
    public disponsableEditPrice(dialogReference) {
        this.disposableSubscriptions.push(
            dialogReference.componentInstance.saveManualEdit
                .subscribe((responseData) => {
                    if (!responseData.isBetterPrice) {
                        this.stock.editedPrice = responseData.value;
                    } else {
                        this.stock.editedPrice = 0;
                    }
                }),
        );
    }

    public ngOnDestroy() {
        this.disposableSubscriptions.forEach((subscription) => {
            if (subscription) subscription.unsubscribe();
        });
    }

    public aboutFeesCall() {
        const reference = this.dialogsServices.showComponentAsAsidePanel(CheckoutAboutFeesComponent, true);
        this.dialogAboutFeesReference = reference as MatDialogRef<CheckoutAboutFeesComponent>;
    }
}
